import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";

/**
 * MeetTheTeam component
 * @param service service object
 * @param users users object
 * @param { string } department String of flaunt department name
 * @returns Returns a team grid
 */
const MeetTheTeam = ({ service, users, department }) => {

    return(
        <div className="author-team">
            <h2 className="h1">meet the team</h2>
            <p className="author-team-description">{ service?.services_fields_information?.fieldServicesFieldsInformationIntro }</p>
            <div className="author-team-users">
                {
                    users && users.map((user) => {
                        return(
                            <a 
                                href={ `/authors/${user?.slug}` }
                                key={`user-card-${user?.slug}`}
                                className={`user-card team-slide-out-child service-colour-border-usercard-${department}`}
                            >
                                <GatsbyImage image={ user?.user_department_information.customUserProfileImage?.localFile?.childImageSharp?.gatsbyImageData } className="lazyload" alt={ user?.name } />
                                <div className={`user-card-information`}>
                                    <p className="user-card-information-name" dangerouslySetInnerHTML={{  __html: user.name }}></p>
                                </div>
                            </a>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default MeetTheTeam;